import type { BrandTypes } from '@ps/platform-message-framework/common/BrandTypes';
import type { ClientPlatform } from '@ps/platform-message-framework/common/ClientPlatform';
import type { LicenceId } from '@ps/platform-message-framework/common/LicenceId';
import type { Sites } from '@ps/platform-message-framework/common/Sites';
import type { FeatureFlag } from '@ps/web-core-enums';
import { ResolverTag } from '@ps/web-core-enums';
import type { RouteComponentProps } from 'react-router-dom';

import type { PostMessage } from '@swf/core/enums';

export enum Department {
  Balances = 'balances',
  BankID = 'bankId',
  ConvertCurrencies = 'convert-currencies',
  Deposit = 'deposit',
  History = 'history',
  Home = 'home',
  P2pTransfer = 'p2p-transfer',
  Paywall = 'paywall',
  PlayMoney = 'playmoney',
  PreferredCurrency = 'preferred-currency',
  RMF = 'rmf',
  Withdraw = 'withdraw'
}

export const BonusTags = {
  'free-spin-bonuses': ResolverTag.FreeSpinBonus,
  'instant-bonuses': ResolverTag.InstantBonus,
  bonuses: ResolverTag.BonusesReleaseAndInstant,
  'sports-bonus-cash': ResolverTag.Cashbonus,
  'game-tickets': ResolverTag.MinigameTicket,
  'free-bets': ResolverTag.ISPFreeBets
};

export enum RollType {
  InstantBonuses,
  FreeSpinBonuses,
  GameTickets
}

export interface Data {
  data:
    | {
        command: PostMessage;
        data: { c2l: string };
        arguments: string[];
        msgId: string;
        rollType: number;
      }
    | string;
}

export interface ResolverQuery {
  opencontext?: string;
  ram?: number;
  applePaySupported?: boolean;
  language?: string;
  country?: string;
  userId?: string;
  timezone?: number;
  iceParam?: 'leaderboardid' | 'promoid';
  u?: string;
  platform?: string;
  brand?: string;
}

export interface Params {
  bonusId?: string;
  bonusType?:
    | 'free-spin-bonuses'
    | 'instant-bonuses'
    | 'game-tickets'
    | 'bonuses'
    | 'sports-bonus-cash'
    | 'free-bets';
  department?: Department;
  icegame?: string;
  icegameId?: string;
  trigger?: string;
}

export interface ResolverProps {
  assetUrl: string;
  brand?: BrandTypes;
  brandName?: string;
  close?(path: string): void;
  country?: string;
  emailValidated: boolean;
  embedded?: boolean;
  embeddedRoute?: boolean;
  features: Partial<{ [key in FeatureFlag]: boolean }>;
  firstSession?: boolean;
  generatePath?(): string;
  getTokenAndSignature(): { token: string; signature: string };
  isPlayMoney?: boolean;
  isRealMoneyOK: boolean;
  isReloader?: boolean;
  language: string;
  license: LicenceId;
  searchParams: Record<string, string | number>;
  migrationRequired: boolean;
  migrationTarget?: number;
  navigate(path: string): void;
  params: Params;
  pathname: string;
  platform?: ClientPlatform;
  push?(path: string): void;
  routes?: { [key: string]: string };
  setPendingNotifications(): void;
  site?: Sites;
  styles?: Record<string, string> & { iframeModal: string };
}

export interface HandleMessageProps {
  c2lHandler(c2l: string): void;
  close?(path?: string): void;
  data: Data['data'];
  dataIntegrityCheckFailed: boolean;
  depositLimitPath: string;
  license: LicenceId;
  logout(props?: object): void;
  modalReplace(props: { path: string }[]): void;
  postMessage?(): void;
  push: RouteComponentProps['history']['push'];
  quickAccountCreationRequired: boolean;
  refreshAccount(): void;
  setMitIdWc2Data(props: object): void;
}
